<template>
  <div dir="rtl">
    <!-- ---tpb -->

    <!-- <div style="width: 165px !important" dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->

    <!-- ---nanosoft -->

    <div style="width: 120px !important" dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <!-- ---esdf -->
    <!-- <div dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->

    <!-- ---raba // lcma -->

    <!-- null -->

    <div :class="{ 'mt-shortName': (alldata.shortName = null) }"></div>
    <h3 style="font-size: 30px" class="text-center">{{ alldata.fullName }}</h3>
    <h3 style="font-size: 20px" class="text-center">{{ alldata.shortName }}</h3>
    <h3 class="text-center">كشف الحضور والإنصراف</h3>
    <div>
      <h3 style="font-size: 20px" class="text-center">
        من <span style="margin-left;: 10px">{{ convert(date) }}</span> الى<span
          style="margin-right: 10px"
          >{{ convert(DateTo) }}</span
        >
      </h3>
    </div>
    <h3 v-if="Department != ''" style="font-size: 20px" class="text-center">
      التابع لـ {{ alldata.items[0].departmentName }}
    </h3>
    <h3 v-else style="font-size: 20px; height: 28px" class="text-center"></h3>

    <div style="margin-top: 50px" class="container body">
      <div>ر.م</div>
      <div>الموظف</div>
      <div>رقم الموظف</div>
      <div>مجموع الغياب</div>
      <div v-for="(item, id) in filteredDetails" :key="id">
        {{ day_n(item.date) + "-" + convertDayString(item.dayString) }}
      </div>
    </div>
    <div v-for="(item, i) in itemsWithRepeats" :key="i">
      <div v-if="item.isRepeatBlock">
        <div style="margin-top: 50px" class="container body">
          <!-- <div>{{ item.isRepeatBlock ? ( i = i + 1) : i  }}</div> -->
          <div>ر.م</div>
          <div>الموظف</div>
          <div>رقم الموظف</div>
          <div>مجموع الغياب</div>
          <div v-for="(item, id) in filteredDetails" :key="id">
            {{ day_n(item.date) + "-" + convertDayString(item.dayString) }}
          </div>
        </div>
      </div>

      <!-- :class="{ 'custom-mt': i / 7 == 1  , 'custom-mt3': i / 16 == 1   ,'custom-mt6' :  i / 74 == 1 ,'custom-mt4' : i / 96 == 1  ,'custom-mt5' :   i / 30 == 1 || i / 41 == 1  , 'custom-mt2':       i / 118 == 1 || i / 140 == 1 || i / 162 == 1 || i / 184 == 1 || i / 206 == 1 || i / 228 == 1 || i / 250 == 1 || i / 272 == 1 }">  -->
      <div v-else>
        <div
          :style="
            i % 2 == 1 ? { background: '#f5f5f5' } : { background: '#fff' }
          "
          :key="i"
          class="container"
          :class="{
            'custom-mt': i / 7 == 1,
            'custom-mt-97': i / 97 == 1,
            'custom-mt3':
              i / 16 == 1 ||
              i / 25 == 1 ||
              i / 34 == 1 ||
              i / 43 == 1 ||
              i / 52 == 1 ||
              i / 61 == 1 ||
              i / 70 == 1 ||
              i / 79 == 1 ||
              i / 88 == 1 ||
              i / 106 == 1 ||
              i / 115 == 1
          }"
        >
          <div v-if="i + 1 == 8">{{ i + 1 }}</div>
          <div v-else-if="i + 1 >= 118">{{ i - 12 }}</div>

          <div v-else-if="i + 1 >= 109">{{ i - 11 }}</div>

          <div v-else-if="i + 1 >= 100">{{ i - 10 }}</div>

          <div v-else-if="i + 1 >= 90">{{ i - 9 }}</div>
          <!-- <div v-else-if="(i + 1) ==  88 ">100</div>
                <div v-else-if="(i + 1) ==  89 ">{{ i+1 }}</div> -->
          <div v-else-if="i + 1 >= 81">{{ i - 8 }}</div>
          <div v-else-if="i + 1 >= 72">{{ i - 7 }}</div>
          <div v-else-if="i + 1 >= 63">{{ i - 6 }}</div>
          <div v-else-if="i + 1 >= 55">{{ i - 5 }}</div>
          <div v-else-if="i + 1 >= 45">{{ i - 4 }}</div>
          <div v-else-if="i + 1 >= 36">{{ i - 3 }}</div>
          <div v-else-if="i + 1 >= 27">{{ i - 2 }}</div>
          <div v-else-if="i + 1 >= 18 && i + 1 < 28">{{ i - 1 }}</div>
          <div v-else-if="i + 1 == 25">100</div>
          <div v-else-if="i + 1 < 8">{{ i + 1 }}</div>
          <div v-else>{{ i }}</div>
          <div>{{ item.employeeName }}</div>

          <div>{{ item.jobNumber }}</div>

          <div>{{ item.totalAbsents }}</div>

          <div
            v-for="(detail, idl) in item.details"
            :key="idl"
            :style="
              detail.dayTypeString == 'عطلة'
                ? { 'background-color': '#d3d3d3' }
                : detail.dayType === 1
                ? { display: 'none' }
                : i % 2 == 1
                ? { background: '#f5f5f5' }
                : { background: '#fff' }
            "
          >
            <div v-if="detail.dayType == 3">
              <p>-</p>
              <p>إجازة</p>
            </div>
            <div v-else-if="detail.currentSituation == 4">
              <p>-</p>
              <p>متفرغ</p>
            </div>

            <div v-else-if="detail.currentSituation == 5">
              <p>-</p>
              <p>مكلف</p>
            </div>
            <div v-else-if="detail.currentSituation == 6">
              <p>-</p>
              <p>تدريب</p>
            </div>
            <div v-else-if="detail.currentSituation == 2">
              <p>-</p>
              <p>منتدب</p>
            </div>
            <div v-else-if="detail.dayTypeString == 'عطلة'">
              <p>-</p>
              <p>عطلة</p>
            </div>

            <div v-else-if="detail.excuseType == '4'">
              <p>
                {{
                  detail.attendanceTime == null
                    ? "-"
                    : convertTime(detail.attendanceTime)
                }}
              </p>
              <p>عذر</p>
            </div>

            <div v-else-if="detail.excuseType == '3'">
              <p>-</p>
              <p>غائب بعذر</p>
            </div>
            <div v-else>
              <p>
                {{
                  detail.attendanceTime == null
                    ? "-"
                    : convertTime(detail.attendanceTime)
                }}
              </p>
              <p>
                {{
                  detail.leaveTime == null ? "-" : convertTime(detail.leaveTime)
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div  style="margin-top: 50px; " class="container body">
            
            <div >ر.م</div>
            <div>الموظف</div>
            <div>رقم الموظف</div>
            <div>مجموع الغياب</div>
            <div v-for="(item, id)  in items[0].details " :key="id"
                v-if="!(convertDayString(item.dayString) == 'ج' && convertDayString(item.dayString) != 'س' || convertDayString(item.dayString) != 'ج' && convertDayString(item.dayString) == 'س')">
                {{ day_n(item.date) + "-" + convertDayString(item.dayString) }}
            </div>
        </div> -->
  </div>
</template>

<script>
import { time } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: {
    DateTo: String,
    date: String,
    pathLogo: String,
    Department: String,
    items: [Array, Object],
    alldata: [Array, Object]
  },

  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      red: "#ecbbbb",
      blue: "#adc8f5",
      green: "#7ecf81",
      m: env.mTop()
    };
  },

  computed: {
    itemsWithRepeats() {
      const repeatedItems = [];
      var repeatAfter = 8;
      var x = false;
      for (let i = 0; i < this.items.length; i++) {
        repeatedItems.push(this.items[i]);
        if ((i + 1) % repeatAfter == 0) {
          repeatedItems.push({ isRepeatBlock: true });
        } else {
        }
      }
      return repeatedItems;
    },
    // تفاصils اليوم مع استبعاد أيام عطلة الأسبوع (dayType === 1)
    filteredDetails() {
      if (!this.items || !this.items[0] || !this.items[0].details) {
        return [];
      }
      return this.items[0].details.filter(item => item.dayType !== 1);
    }
  },
  methods: {
    day_n(event) {
      let d = new Date(event);
      let fullDay = d.getDate();

      return fullDay;
    },

    convertDayString(event) {
      let day;
      switch (event) {
        case "الخميس":
          day = "خ";
          break;
        case "الجمعة":
          day = "ج";
          break;
        case "السبت":
          day = "س";
          break;
        case "الأحد":
          day = "ح";
          break;
        case "الاثنين":
          day = "ن";
          break;
        case "الثلاثاء":
          day = "ث";
          break;
        case "الأربعاء":
          day = "ع";
      }

      return day;
    },

    day3(event, id) {
      try {
        let d = new Date(event);
        let fullDay = new Date(
          d.getMonth() + 1 + "/" + id + "/" + d.getFullYear()
        );
        // alert(fullDay)
        // var days = [' - Su', ' - Mo', ' - Tu', ' - We', ' - Th', ' - Fr', ' - Sa'];
        var days = ["ح", "ن", "ث", "ع", "خ", "ج", "س"];
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }

        if (
          (days[fullDay.getDay()] == "ج" && days[fullDay.getDay()] != "س") ||
          (days[fullDay.getDay()] != "ج" && days[fullDay.getDay()] == "س")
        ) {
          return false;
        }
      } catch (error) {}
    },

    day2(event, id) {
      try {
        let d = new Date(event);
        let fullDay = new Date(
          d.getMonth() + 1 + "/" + id + "/" + d.getFullYear()
        );
        // alert(fullDay)
        // var days = [' - Su', ' - Mo', ' - Tu', ' - We', ' - Th', ' - Fr', ' - Sa'];
        var days = [" - ح", " - ن", " - ث", " - ع", " - خ", " - ج", " - س"];
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return days[fullDay.getDay()];
      } catch (error) {}
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    convertTime(event) {
      try {
        var time = event;
        var resultArray = time.split(":");

        return time.replace(":" + resultArray[2], "");
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/TimesheetD_n";

.col_color {
  margin-top: 60px;
  direction: rtl;
  color: black;
  background-color: rgb(236, 187, 187);
  padding: 0px 10px 0px 10px;
  margin-left: 10px;
}

.custom-mt {
  margin-bottom: 200px !important;
}

.custom-mt2 {
  margin-bottom: 350px !important;
}

.custom-mt3 {
  margin-bottom: 400px !important;
}

.custom-mt-97 {
  margin-bottom: 450px !important;
}

.custom-mt4 {
  margin-bottom: 112px;
}

.custom-mt5 {
  margin-bottom: 49px;
}

.custom-mt6 {
  margin-bottom: 92px;
}

.mt-shortName {
  margin-top: 68px;
}

.pathLogo-mt {
  margin-top: 153px !important;
}
</style>
